<template>
  <div class="filters-container mb-5">
    <div class="filter-header mb-3">
      <span class="label">Filters</span>
      <button
        class="button is-small is-text has-text-link"
        @click="resetFilters"
      >
        Reset all
      </button>
    </div>

    <div class="filter-buttons">
      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.daysInStock !== 'All' }"
        @click="toggleFilter('daysInStock')"
      >
        <span>days in stock</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.nearlyNew !== 'All' }"
        @click="toggleFilter('nearlyNew')"
      >
        <span>nearly new</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.percentOfPercayso !== 'All' }"
        @click="toggleFilter('percentOfPercayso')"
      >
        <span>percent of percayso</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.sold !== 'All' }"
        @click="toggleFilter('sold')"
      >
        <span>sold</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.marketDemand !== 'All' }"
        @click="toggleFilter('marketDemand')"
      >
        <span>market demand</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.make !== 'All' }"
        @click="toggleFilter('make')"
      >
        <span>make</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.model !== 'All' }"
        @click="toggleFilter('model')"
      >
        <span>model</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.dealerType !== 'All' }"
        @click="toggleFilter('dealerType')"
      >
        <span>dealer type</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.mileage !== 'All' }"
        @click="toggleFilter('mileage')"
      >
        <span>mileage</span>
      </button>

      <button
        class="button is-size-7 has-text-weight-semibold has-text-dark is-outlined"
        :class="{ 'is-active': selectedFilters.fuelType !== 'All' }"
        @click="toggleFilter('fuelType')"
      >
        <span>fuel type</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockCompareFilters',
  data() {
    return {
      selectedFilters: {
        daysInStock: 'All',
        nearlyNew: 'All',
        percentOfPercayso: 'All',
        sold: 'All',
        marketDemand: 'All',
        make: 'All',
        model: 'All',
        dealerType: 'All',
        mileage: 'All',
        fuelType: 'All'
      }
    }
  },
  methods: {
    toggleFilter(filterType) {
      this.selectedFilters[filterType] =
        this.selectedFilters[filterType] === 'All' ? 'Active' : 'All'

      this.$emit('filter-changed', {
        filterType,
        value: this.selectedFilters[filterType],
        allFilters: { ...this.selectedFilters }
      })
    },

    resetFilters() {
      Object.keys(this.selectedFilters).forEach(key => {
        this.selectedFilters[key] = 'All'
      })
      this.$emit('filters-reset', { ...this.selectedFilters })
    }
  }
}
</script>

<style scoped>
.filters-container {
  background: white;
  padding: 1rem 0;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.button.is-outlined.is-active {
  background-color: #19a5cc;
  border-color: #19a5cc;
  color: white !important;
}

.button.is-outlined.is-active:hover {
  background-color: #2366d1;
  border-color: #2366d1;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-buttons {
    gap: 0.25rem;
  }

  .filters-container {
    padding: 0.75rem;
  }
}
</style>
